module.exports = __webpack_public_path__ + "static/media/peda_back_view.a6e20214.gif";